import { atom, Setter } from 'jotai';

import { uploadDepositClientFiles } from 'api/rest/payments/uploadDepositClientFiles';
import { setDepositToPaid } from 'api/rest/traders/setDepositToPaid';
import { PaginationResponse } from 'data/common/models';
import { refreshTraderBalanceAtom } from 'data/traders/account/atoms/traderBalanceAtom';
import { getDataAtom } from 'utils/atoms/dataAtom';
import {
  getDataFetchingAtom,
  getDataRefreshingAtom,
} from 'utils/atoms/dataFetchingAtom';
import { fetchPagination } from 'utils/atoms/fetchPagination';
import { mapAtomValue } from 'utils/remote';

import { getDepositsWithDefaultStatuses } from './getDepositsWithDefaultStatuses';
import { ACTIVE_STATUSES, TraderDeposit } from '../models/TraderDeposit';

export const activeDepositsAtom = getDataAtom<TraderDeposit[]>();

export const activeDepositsPagesAtom = getDataAtom<PaginationResponse<never>>();

export const fetchActiveDepositsAtom = getDataFetchingAtom(
  activeDepositsAtom,
  fetchPagination(
    activeDepositsPagesAtom,
    getDepositsWithDefaultStatuses(ACTIVE_STATUSES, 'asc'),
  ),
);

export const refreshActiveDepositsAtom = getDataRefreshingAtom(
  activeDepositsAtom,
  fetchPagination(
    activeDepositsPagesAtom,
    getDepositsWithDefaultStatuses(ACTIVE_STATUSES, 'asc'),
  ),
);

const removeActiveDeposit = (id: string, set: Setter) => {
  set(
    activeDepositsAtom,
    mapAtomValue((items) => items.filter((item) => item.id !== id)),
  );
};

export const completeDepositAtom = atom(null, async (_, set, id: string) => {
  await setDepositToPaid(id);
  removeActiveDeposit(id, set);
  //   set(payoutsCountAtom, mapAtomValue(updateCounts(updated)));
  set(refreshTraderBalanceAtom);
});

interface DepositUploaFilesRequest {
  id: string;
  files: FormData;
}

export const uploadDepositClientFilesAtom = atom(
  null,
  async (_, set, { id, files }: DepositUploaFilesRequest) => {
    await uploadDepositClientFiles(id, files);
  },
);
